import React, { useReducer, useEffect } from "react";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import {
    TourContent,
    TourHeader,
    TourDescription,
    TourDescriptionSteps,
    TooltipBody,
    TooltipContent,
    TooltipFooter,
    NextButton,
    BackButton,
    CloseButton,
    DivCloseButton,
} from "./styles"
import ImageWelcomeTour from "./images/welcomeTour";

const TOUR_STEPS = [
    {
        target: 'body',
        content:
            <TourContent>
                <TourHeader>Seja bem vindo ao Sankhya ID!!!</TourHeader>
                <TourDescription>
                    Agora vamos te mostrar as funcionalidades presentes no seu Sankhya ID.
                </TourDescription>
                <ImageWelcomeTour />
            </TourContent>,
        placement: 'center',
    },
    {
        target: ".ant-menu-group-data-user",
        content:
            <TourContent>
                <TourHeader>Menus laterais</TourHeader>
                <TourDescriptionSteps>
                    <p>Nesses menus você encontrará as configurações e informações necessárias do seu ID.</p>
                </TourDescriptionSteps>
            </TourContent>,
        placement: 'right',
    },
    {
        target: ".item-menu-data-user",
        content:
            <TourContent>
                <TourHeader>Meu ID</TourHeader>
                <TourDescriptionSteps>
                    <p>Neste menu, você poderá editar os seus dados pessoais e profissionais.</p>
                    <p><strong>Dica: </strong>Sempre mantenha os seus dados profissionais atualizados para garantir
                        uma melhor experiência nas soluções Sankhya.</p>
                </TourDescriptionSteps>
            </TourContent>,
        placement: 'right',
    },
    {
        target: ".item-menu-security-login",
        content:
            <TourContent>
                <TourHeader>Segurança e login</TourHeader>
                <TourDescriptionSteps>
                    <p>Neste menu, você poderá editar a sua senha, e-mail principal e de recuperação.</p>
                    <p><strong>Dica: </strong>Preencha com um e-mail pessoal o campo de e-mail de recuperação para que
                        no futuro você possa recuperar o seu ID, caso não tenha mais acesso ao seu e-mail principal.</p>
                </TourDescriptionSteps>
            </TourContent>,
        placement: 'right',
    },
    {
        target: ".item-menu-my-permissions",
        content:
            <TourContent>
                <TourHeader>Minhas permissões</TourHeader>
                <TourDescriptionSteps>
                    <p>Neste menu, você poderá visualizar todas as permissões que você possui e até mesmo
                        retirá-las caso seja necessário.</p>
                </TourDescriptionSteps>
            </TourContent>,
        placement: 'right',
    },
    {
        target: ".item-menu-my-certifications",
        content:
            <TourContent>
                <TourHeader>Minhas certificações</TourHeader>
                <TourDescriptionSteps>
                    <p>Neste menu, você poderá visualizar todas as suas certificações adquiridas na Universidade Sankhya.</p>
                </TourDescriptionSteps>
            </TourContent>,
        placement: 'right',
    },
];

const INITIAL_STATE = {
    run: false,
    continuous: true,
    loading: false,
    stepIndex: 0,
    steps: TOUR_STEPS,
    key: new Date(),
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "START":
            return { ...state, run: true };
        case "RESET":
            return { ...state, stepIndex: 0 };
        case "STOP":
            return { ...state, run: false };
        case "NEXT_OR_PREV":
            return { ...state, ...action.payload };
        case "RESTART":
            return {
                ...state,
                stepIndex: 0,
                run: true,
                loading: false,
                key: new Date(),
            };
        default:
            return state;
    }
};

const Tooltip = ({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
}) => (
    <TooltipBody {...tooltipProps} className="tooltip-body">
        <TooltipContent className="tooltip-content">{step.content}</TooltipContent>
        <TooltipFooter className="tooltip-footer">
            <DivCloseButton>
                <CloseButton {...closeProps}>{closeProps.title}</CloseButton>
            </DivCloseButton>

            {index > 0 && (
                <BackButton {...backProps}>{backProps.title}</BackButton>
            )}
            {continuous && (
                <NextButton {...primaryProps}>{primaryProps.title}</NextButton>
            )}
        </TooltipFooter>
    </TooltipBody>
);

const Tour = ({ start }) => {
    const [tourState, dispatch] = useReducer(reducer, INITIAL_STATE);

    useEffect(() => {
        if (start) {
            window.startTour();
        }
    }, [start]);

    const callback = (data) => {
        const { action, index, type, status } = data;

        if (
            action === ACTIONS.CLOSE ||
            (status === STATUS.SKIPPED && tourState.run) ||
            status === STATUS.FINISHED
        ) {
            dispatch({ type: "STOP" });
        } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
            dispatch({
                type: "NEXT_OR_PREV",
                payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
            });
        }
        if(status === STATUS.FINISHED) {
            window.startTourHub();
        }
    };

    const startTour = () => {
        dispatch({ type: "RESTART" });
    };

    window.startTour = startTour;

    return (
        <JoyRide
            {...tourState}
            tooltipComponent={Tooltip}
            callback={callback}
            locale={{
                last: "Próximo >",
                back: "< Voltar",
                next: "Próximo >",
                close: "Fechar"
            }}
        />
    );
};

export default Tour;
